
export const getUserStorage = () => {
    return JSON.parse(localStorage.getItem('agentUser'))
}